import styled, { css } from 'styled-components';
import { ExportIcon } from '../../Icons';

export const Container = styled('div')`
  .modal-body {
    height: auto;
    min-height: 100px;

    overflow: ${(props) => props.showChartPreview ? 'auto' : 'visible'};
  }

  & > section > div {
    min-height: 251px;
    height: auto;
  }

  @media (max-width: 597px) {
    .modal-body {
      height: 100%;
    }

    & > section > div {
      height: 100%;
    }
  }

  ${(props) => props.okBtnDisabled && css`
    & > section button:nth-of-type(2) {
      pointer-events: none;
      background: ${props.theme.colors.exportingPopupBtnDisabled};
      color: #FFF;
      opacity: 0.6;
    }
  `}

  ${(props) => !props.okBtnDisabled && css`
    & > section button:nth-of-type(2) {
      background: ${props.theme.colors.exportingPopupOkBtn};
    }

    & > section button:nth-of-type(2):hover{
      background-color: ${(props) => props.theme.colors.normalButtonHoverBackgroundColor};
      color: ${(props) => props.theme.colors.normalButtonHoverTextColor};
    }
  `}

  & > section > div > div:nth-child(3) > button:nth-child(1) {
      background: transparent;
      color: ${(props) => props.theme.colors.exportingPopupBackBtnColor};
  }

  .seletor-wrapper {
    background: ${(props) => props.theme.colors.exportingPopupSeletorBackgroundColor};
    border: 1px solid ${(props) => props.theme.colors.exportingPopupSeletorBodyBorderColor};
    color: #610082 !important;

    .seletor-head {
      background-color: transparent;
      height: 30px; //50% da altura da área do parente
      .title {
        color: ${(props) => props.theme.colors.exportingPopupTitleColor} !important;
      }
    }

    .seletor-body {
      background: ${(props) => props.theme.colors.exportingPopupSeletorBackgroundColor};
      border-right: 1px solid ${(props) => props.theme.colors.exportingPopupSeletorBodyBorderColor} !important;
      border-left: 1px solid ${(props) => props.theme.colors.exportingPopupSeletorBodyBorderColor} !important;
      border-bottom: 1px solid ${(props) => props.theme.colors.exportingPopupSeletorBodyBorderColor} !important;
      .option-label {
        color: #610082 !important;
      }
    }
  }
`;

export const Wrapper = styled.div`
  width: 100%;
`;

export const Action = styled.div`
  margin-top: 16px;
`;

export const ChartExportIcon = styled(ExportIcon)`
    fill: ${(props) => props.theme.cardExporting.iconColor};
`;

export const Label = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.cardExporting.iconColor}
`;

export const LoadingWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  // Loading spinner
  & > div {
    padding-bottom: 0;
  }

  // Helper text
  & > span {
    margin-top: 16px;
    align-self: center;
  }
`;
